<span style="margin-top: 1rem">
  <span (click)="backToResourcesList()" class="returnButton">
    {{ resourcesReturnLabel }}
  </span>
</span>
<app-header
  data-testid="device-details-header"
  [subtitle]="pageSubtitle"
  [title]="pageTitle"
>
  <a
    *ngIf="authorizedLogUiHref(profile$ | async) as href"
    [href]="href"
    class="open-logui-link"
    target="_blank"
    rel="noopener noreferrer"
    header-title-action
  >
    {{ 'drone.flight_his.open_in_logui' | translate }}
  </a>
  <div *ngIf="device" class="device-header-actions" header-button>
    <button
      type="button"
      class="refresh-device-button"
      [attr.aria-label]="'Device_details.refresh' | translate"
      [matTooltip]="'Device_details.refresh' | translate"
      (click)="refreshDeviceData()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
    <ng-container *ngIf="profile$ | async as profile">
      <app-button
        *ngIf="canEditDevice(profile)"
        (click)="editDevice()"
        [black]="true"
        [title]="'Device_details.edit' | translate"
        class="flex-position-end"
        testId="device-details-edit-button"
      >
      </app-button>
    </ng-container>
  </div>
</app-header>
<div *ngIf="errorMessage" class="error-message">
  {{ errorMessage }}
</div>
<section class="device-summary-section">
  <div class="device-info-column">
    <div class="device-info-block">
      <div class="table-header">
        <h1>{{ 'Drone_details.general_info' | translate }}</h1>
        <div class="line-part"></div>
      </div>
      <app-general-device-info
        data-testid="device-general-info"
        [generalInfoItems]="generalInfoItems"
      >
      </app-general-device-info>
    </div>
    <div *ngIf="devicePropertyItems.length" class="device-info-block">
      <div class="table-header">
        <h1>{{ 'Device_details.device_properties' | translate }}</h1>
        <div class="line-part"></div>
      </div>
      <app-general-device-info [generalInfoItems]="devicePropertyItems">
      </app-general-device-info>
    </div>
  </div>
  <div class="device-image" *ngIf="deviceImageSrc">
    <img [alt]="'Drone_details.image_alt' | translate" [src]="deviceImageSrc" />
  </div>
</section>
<app-device-license-segment
  *ngIf="hasLicenses && (isLicenseManagementEnabled$ | async)"
  [deviceId]="deviceId"
  [deviceName]="pageSubtitle || null"
  [companyId]="deviceCompanyId"
  [licenseBatches]="linkedLicenseBatches"
  [artifactOverrides]="device?.softwareVersionOverrides?.artifactOverrides"
  [bundleOverrides]="device?.softwareVersionOverrides?.bundleOverrides"
  [unresolvedOverrideIds]="
    device?.softwareVersionOverrides?.unresolvedOverrideIds
  "
  [softwareSelectionResolutions]="device?.licenseRedemptionInfo?.components"
  (licenseBatchesChange)="linkedLicenseBatches = $event"
  (deviceRefreshRequested)="refreshDeviceData()"
  [profile]="(profile$ | async) || null"
></app-device-license-segment>
<section class="device-activity-section" *ngIf="device">
  <app-device-activity-section
    [device]="device"
    [profile]="(profile$ | async) || null"
  ></app-device-activity-section>
</section>
<app-device-certificates
  *ngIf="device?.certificates?.length"
  [certificates]="device?.certificates"
  [canRevoke]="
    !!(profile$ | async)?.isMasteradmin ||
    (profile$ | async)?.role === UserRole.ADMIN
  "
  (certificateRevoked)="refreshDeviceData()"
></app-device-certificates>
<app-device-history
  *ngIf="device"
  [history]="device.deviceHistory"
  [hasLicenses]="device.deviceManagementFeatures?.hasLicenses"
></app-device-history>
